import React from 'react';
import { useNavigate } from 'react-router';
import { Button, Card, CardFooter, useApi } from '@axiom/ui';
import type {
  AfcCandidateSearch,
  SavedCandidate,
  User,
  Candidate,
} from '@axiom/validation';

import { isLpUser } from '../../utils/roles-util';
import { LinkUtil } from '../../utils/link-util';
import { TaxonomyApi } from '../../api/taxonomy-api';
import { TalentCardContent } from '../TalentCardContent/TalentCardContent';

export type TalentSearchCardProps = {
  candidate: Candidate | AfcCandidateSearch | SavedCandidate['candidate'];
  user: User;
  setInquiredCandidate: React.Dispatch<
    React.SetStateAction<AfcCandidateSearch | null>
  >;
  isPricingShown?: boolean;
};

export const TalentSearchCard = ({
  candidate,
  user,
  setInquiredCandidate,
  isPricingShown,
}: TalentSearchCardProps) => {
  const navigate = useNavigate();
  const [{ data: taxonomy }] = useApi(TaxonomyApi.readTaxonomy());

  return (
    <Card name="TALENT_SEARCH_CARD">
      <TalentCardContent
        candidate={candidate}
        user={user}
        taxonomy={taxonomy}
        isPricingShown={isPricingShown}
      />
      <CardFooter stackableOn="mobile">
        <Button
          name="VIEW_FULL_BIO_BUTTON"
          variation="outline"
          onClick={async () =>
            navigate(LinkUtil.getSharePath(candidate, taxonomy))
          }
        >
          View Full Bio
        </Button>
        <Button
          disabled={isLpUser(user)}
          variation="outline"
          name="CONTACT_AXIOM_BUTTON"
          onClick={() => {
            setInquiredCandidate(candidate as AfcCandidateSearch);
          }}
        >
          Contact Axiom
        </Button>
      </CardFooter>
    </Card>
  );
};
